import React from "react";
import Skeleton from "react-loading-skeleton";
import styles from "../EventFeature.module.css";

const EventFeatureSkeleton = () => {
  return (
    <div className={styles.Features}>
      <h2 className={styles.Title}>
        <Skeleton count={1} style={{ width: "55%" }} />
      </h2>
      <div className={styles.Item} style={{ width: "70%", margin: "auto" }} >
        <Skeleton height={522}  />
      </div>
    </div>
  );
};

export default EventFeatureSkeleton;
